import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=e2b5d352&scoped=true&"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=e2b5d352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b5d352",
  null
  
)

export default component.exports